import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import Link from "next/link";
import PropTypes, { string } from "prop-types";
import { useSelector } from "react-redux";
import CategoryViewItem from "../../component/categories-viewer/CategoryViewItem";
import { getRelativeImagePath } from "../../util/helper/getRelativeImagePath";
import SliderCard from "./SliderCard";
import styles from "./manufacturer.module.scss";

function Tier1(props: any) {
  const {
    url, title, imgSrc, manufacturer, tier0, tier1, tier2,
  } = props;
  const { t } = useTranslation(["category-map", "category-map-t2"]);
  const t2 = (_: string) => t(_, { ns: "category-map-t2" });

  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  // console.log(selectedVehicle, url);
  const categoryImageSrc = (imgSrc && `/cms/${imgSrc}`) || "/images/common/image-not-available_16051144.png";

  let categoryTitle = tier2;
  if (!categoryTitle) {
    categoryTitle = tier1;
  }

  const translation = t(categoryTitle);
  let finalTranslation = translation === categoryTitle ? t2(categoryTitle) : translation;

  // hot fix for Performance Parts
  if (tier0 === "Performance Parts") {
    finalTranslation = `Performance ${finalTranslation}`;
  }

  const CategoryBox = () => (
    <div className={styles.category_item}>

      <Image
        width={130}
        height={130}
        unoptimized
        src={getRelativeImagePath(categoryImageSrc)}
        alt={title}
      />
      <div className={styles.category_item_heading_wrapper}>
        <PAText
          component="h3"
          fontSize={FONT_SIZE[2]}
          className={styles.category_item_heading}
        >
          {finalTranslation}
        </PAText>
      </div>

    </div>
  );

  if (!selectedVehicle) {
    return (
      (<Link
        key={url}
        href={url}
      >

        <CategoryBox />

      </Link>)
    );
  }
  return (

    <CategoryViewItem
      key={url}
      categoryObj={{
        tier0,
        tier1,
        tier2,
      }}
      defaultFilters={{
        manufacturers: [manufacturer.toUpperCase()],
      }}
    >

      <a>

        <CategoryBox />
      </a>
    </CategoryViewItem>
  );
}

const Categories = (props: any) => {
  const { categories, manufacturer } = props;
  const { t } = useTranslation("category-map");

  return (
    <SliderCard {...{
      categoryUrls: categories,
      title: t("Categories"),
      titleWidth: 200,
    }}
    >
      <Tier1 manufacturer={manufacturer} />
    </SliderCard>
  );
};

Categories.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      extendedDetails: PropTypes.object.isRequired,
    }).isRequired,
  ).isRequired,
  manufacturer: string.isRequired,
};

export default Categories;
